var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toJS } from '@shared/utils/immutable';
import { createSession } from '@store/session/actions';
import { selectCartPrice } from '@store/watchlist/selectors';
import { selectThemeLoading } from '@store/theme/selectors';
import SessionContainer from 'containers/SessionContainer';
import ClickAndCollectPage from '../../components/pages/ClickAndCollect';
var ClickCollect = /** @class */ (function (_super) {
    __extends(ClickCollect, _super);
    function ClickCollect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClickCollect.prototype.render = function () {
        var _this = this;
        return (_jsx(SessionContainer, { children: function (sessionProps) { return (_jsx(ClickAndCollectPage, __assign({}, sessionProps, { createSession: function (deviceId) { return _this.props.createSession(deviceId); }, cartPrice: _this.props.cartPrice, isThemeLoading: _this.props.isThemeLoading }), void 0)); } }, void 0));
    };
    return ClickCollect;
}(Component));
var select = function () { return function (state) { return ({
    cartPrice: selectCartPrice(state),
    isThemeLoading: selectThemeLoading(state),
}); }; };
var mapDispatchToProps = function (dispatch) { return ({
    createSession: function (deviceId) {
        dispatch(createSession(deviceId));
    },
}); };
export default withRouter(connect(select, mapDispatchToProps)(toJS(ClickCollect)));
